<template>
  <section>    
    <v-card elevation="0">
      <v-card-title class="app-card-title">
        <h4 class="text">
          Tipo de documento
        </h4>
      </v-card-title>
      <v-card-text class="app-card-content">          
        <v-form
          ref="form"
          lazy-validation
          @submit.prevent="onSubmit"
        >
          <v-autocomplete
            v-model="documentType.selected"
            :items="documentType.items"
            :rules="[rules.required]"
            :loading="documentType.isLoading"
            label="Tipo Documento *"
            item-text="name"
            color="success"
            return-object
            outlined
            dense
            no-filter
            @update:search-input="onSearch"
          />
          
          <v-btn
            small
            depressed
            color="success"
            type="submit"
            :disabled="documentType.isLoading"
          >
            Adicionar
          </v-btn>         
        </v-form>
      </v-card-text>      
    </v-card>
  </section>
</template>

<script>
  import TipoPedidoService from '@/services/tipo-pedido.service';
  import TipoDocumentService from '@/services/tipo-documento.service';

  export default {
    name: 'TypeSolicitationTypeDocumentForm',

    props: {
      typeSolicitationId: {
        type: Number,
        required: true,
      },
    },
  
    data: () => ({
      documentType: {
        selected: null,
        items: [],
        isLoading: false,
      },

      paginate: {
        page: 1,
        perPage: 20,
      },

      searchTerm: '',
      searchDebounceTimer: null,

      rules: {
        required: value => !!value || 'Esse campo deve ser preenchido'
      },
    }),

    mounted() {
      this.fetchDocumentTypes();
    },

    methods: {
      onSearch(value) {
        if (value === this.searchTerm) return;
        this.searchTerm = value || '';
        clearTimeout(this.searchDebounceTimer);
        this.searchDebounceTimer = setTimeout(() => {
          this.fetchDocumentTypes();
        }, 400);
      },

      fetchDocumentTypes() {
        this.documentType.isLoading = true;
        TipoDocumentService
          .list(this.buildParams())
          .subscribe(({ items }) => {
            this.documentType.items = items;
            this.documentType.isLoading = false;
          }, () => {
            this.documentType.isLoading = false;
          });
      },

      buildParams() {
        const { page, perPage } = this.paginate;

        return {
          input: {
            name: this.searchTerm || undefined,
          },
          inputPage: {
            page,
            per_page: perPage,
            sort: 'name:asc',
          },
        };
      },

      onSubmit(){
        if (!this.$refs.form.validate()) return;

        this.documentType.isLoading = true;

        TipoPedidoService
          .addDocumentType(this.typeSolicitationId, this.documentType.selected.id)
          .subscribe(() => {
            this.$refs.form.reset();
            this.documentType.selected = null;
            this.documentType.isLoading = false;            
            this.$emit('added');
          }, () => {
            this.documentType.isLoading = false;
          });
      }
    }
  }
</script>